// 환경 변수 (Vite는 VITE_ 접두사만 클라이언트에 노출)
// .env.local 파일에 실제 값 작성 (gitignore됨)
export const cfg = {
  // Azure AD
  clientId:        import.meta.env.VITE_AAD_CLIENT_ID   || '',
  tenantId:        import.meta.env.VITE_AAD_TENANT_ID   || 'common',

  // SharePoint
  spSiteId:        import.meta.env.VITE_SP_SITE_ID      || '',
  spDriveId:       import.meta.env.VITE_SP_DRIVE_ID     || '',
  spRootPath:      import.meta.env.VITE_SP_ROOT_PATH    || '/PIUM/전북과학교육원',

  // n8n
  n8nBase:         import.meta.env.VITE_N8N_BASE        || 'https://crodox.app.n8n.cloud',

  // PIUM-DB FastAPI 백업 (n8n Cloud Code Node Python 제약 시)
  pptxApiBase:     import.meta.env.VITE_PPTX_API_BASE   || 'http://100.87.156.92:8001',

  // Planner (수정사항 ↔ Task 동기화 시)
  plannerPlanId:   import.meta.env.VITE_PLANNER_PLAN_ID || '',
};

// 데모 모드: 외부 호출 없이 더미 데이터만 사용
export const DEMO = !cfg.clientId;
